import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ContactAgentDialogLegacy } from "web_myplann/Shared/Components/ContactAgentDialogLegacy";
import { ContactAgentDialogV2 } from "web_myplann/Shared/Components/ContactAgentDialogV2";

type Props = {
	open: boolean;
	isPending?: boolean;
	onClose: () => void;
	onConfirm: (onSuccess: () => void) => void;
	title?: string;
	description?: string;
	buttonLabel?: string;
	successTitle?: string;
	successDescription?: string;
};

const R = Resources.Dashboard.FinancialBalance;

export const ContactAgentDialog: FC<Props> = ({
	title,
	description,
	buttonLabel,
	successTitle,
	successDescription,
	...rest
}) => {
	const { t } = useResource();
	const hasGoalsRight = useGoalsRightOptional();
	const content = {
		...rest,
		title: title ?? t(R.Modal1.title),
		description: description ?? t(R.Modal1.description),
		buttonLabel: buttonLabel ?? t(R.Modal1.button),
		successTitle: successTitle ?? t(R.Modal2.title),
		successDescription: successDescription ?? t(R.Modal2.description),
	};

	return hasGoalsRight ? (
		<ContactAgentDialogV2 {...content} />
	) : (
		<ContactAgentDialogLegacy {...content} />
	);
};
